import * as R from 'remeda'

/**
 * 配列と関数を取り、関数を適用した結果が最大値になる値を返します。
 *
 * @template T - 配列内の値の型。
 * @param items - 配列。
 * @param fn - 関数。
 * @returns 結果の値。
 */
export function maxBy<T>(items: T[], fn: (item: T) => number): T | undefined

/**
 * 関数を取り、関数を適用した結果が最大値になる値を返す関数を返します。
 *
 * @template T - 配列内の値の型。
 * @param fn - 関数。
 * @returns 関数。
 */
export function maxBy<T>(fn: (item: T) => number): (items: T[]) => T | undefined

/**
 * @param args - 引数。
 * @returns 結果または部分適用された関数。
 */
export function maxBy<T>(
  ...args: [fn: (item: T) => number] | [items: T[], fn: (item: T) => number]
): T | ((items: T[]) => T | undefined) | undefined {
  const maxByInner = (items: T[], fn: (item: T) => number) =>
    R.firstBy(items, [fn, 'desc'])

  if (args.length === 1) {
    return (items: T[]) => maxByInner(items, args[0])
  }

  return maxByInner(...args)
}
